<template>
  <div class="d-flex justify-content-center align-items-center py-5">
    <b-spinner label="Loading" />
  </div>
</template>

<script>
// Permission-aware landing for /:clinicUrl/central. Loads the clinic's permission
// context, then redirects to the clinic dashboard when the user can view it
// (C_LEVEL clinic-wide, RDM scoped to their assigned branches) or to clinic user
// management otherwise (e.g. ACCOUNTANT/PROCUREMENT, who hold user.view.clinic but
// not dashboard.clinic.view). Falls back to user management on any error.
export default {
  name: "CentralEntry",
  async created() {
    const clinicUrl = this.$route.params.clinicUrl;
    let target = "ClinicManagement";
    try {
      await this.$store.dispatch("moduleUser/ensurePermissionContextFor", {
        clinicURL: clinicUrl,
      });
      if (this.$store.getters["moduleUser/can"]("dashboard.clinic.view")) {
        target = "ClinicDashboard";
      }
    } catch (err) {
      console.error("CentralEntry: failed to resolve landing page", err);
    }
    this.$router.replace({ name: target, params: { clinicUrl } });
  },
};
</script>
